/**
 * Générateur — Attendu 188 — O6 « Il identifie des translations dans des frises
 * et des pavages. »
 * Niveau : 4ème | Thème #11 Géométrie plane (O6) | Espace et géométrie.
 * Source prof : « TANOED EXERCISEUR ESPACE ET GEOMETRIE 4EME », O6 (Ex.2/3/4 :
 * trier translation / symétrie axiale / symétrie centrale sur des pavages).
 *
 * Plan d'origine (juillet 2026), historique : quatre cartes, « transfo » (quelle
 * transformation envoie le motif 1 sur le motif 2, QCM), « image_numero »
 * (image du motif 1 par une translation de vecteur donné en coordonnées),
 * « vecteur » (coordonnées du vecteur d'un motif à son image, deux cases),
 * « frise » (par quelle transformation une frise est engendrée, QCM). Motif de
 * base : un triangle rectangle SCALÈNE, chiral (ni axe ni centre de symétrie
 * propre) : une translation, une symétrie axiale et un demi-tour en donnent
 * trois copies visuellement distinctes, la transformation est unique.
 *
 * Revue 2026-09-23 (vague 4, la translation), décisions du coordinateur
 * appliquées en mode auto. Plafond, attendus de fin de 4e (Eduscol) : « Il
 * identifie des translations dans des frises et des pavages. » ; exemple de
 * réussite : « Il identifie des translations dans le pavage suivant » (un
 * carrelage). Modèle officiel : test de fin de 4e 2020, question 11, « On
 * considère la translation qui transforme l'hexagone 2 en l'hexagone 12.
 * Quelle est alors l'image de l'hexagone 14 ? ». Cours du professeur : « Une
 * translation fait glisser une figure selon une flèche », « la translation qui
 * envoie A en B », méthode « grouper les figures deux par deux », construction
 * « en comptant les carreaux » ; le mot « vecteur » n'y figure pas.
 *   - Plus aucun « vecteur » ni coordonnées de vecteur (objectif de 3e : BO
 *     2025 l. 1120-1125 ; « aucune connaissance n'est attendue sur l'objet
 *     vecteur » en 4e), plus de « translatés » (absent du cours). Une seule
 *     définition dans les énoncés : « la translation qui transforme le motif i
 *     en le motif j » (Eduscol, question 11).
 *   - Figures : SVG dessinés ICI (quadrillage, pavés, motifs numérotés ; aucun
 *     module partagé touché), en data-URL dans config.imageUrl : imageData
 *     faisait échouer l'enregistrement d'une question modifiée par un
 *     professeur (upload R2). Attribut alt qui décrit la figure sans donner la
 *     réponse. Numéro de chaque motif au centre de son cercle inscrit (toujours
 *     dans le triangle). La balise <desc>, qui portait la réponse, est retirée :
 *     l'ancien en-tête disait qu'un solveur la lisait, c'était faux, aucun
 *     solveur test-side ne couvre 188.
 *   - Carte « Reconnaître la transformation » (transfo_qcm_unique) GARDÉE,
 *     corrigée. Avant : le type était re-tiré à chaque essai rejeté (translation
 *     63,8 % des tirages) et chaque type avait sa position (la seule position
 *     donnait la réponse dans 73,9 %). Le TYPE est maintenant tiré d'abord (un
 *     tiers chacun), puis la position relative du motif 2 (à droite, à gauche,
 *     au-dessus, au-dessous : deux fois sur trois ; en biais : une fois sur
 *     trois), LA MÊME LOI POUR LES TROIS TYPES ; seule la position exacte est
 *     re-tirée. Mesuré sur 10 000 tirages (trois passages) : translation 33 à
 *     34 %, meilleure stratégie qui ne regarde que la position (huit cases) 34
 *     à 35 %, c'est le hasard.
 *     Motif 1 : triangle rectangle de côtés 3 et 2, 4 et 2 ou 4 et 3, dans l'une
 *     de ses huit positions. Choix alignés sur 1245 : « Une translation. », « Une
 *     symétrie axiale. », « Un demi-tour (symétrie centrale). » (plus de
 *     « (un glissement) », « (un miroir) » qui énonçaient le critère). Mode
 *     auto, À ARBITRER : une symétrie axiale ne peut mettre le motif 2 en biais
 *     qu'avec un axe OBLIQUE (à 45°, sur les diagonales des carreaux) ; sans
 *     elle, « en biais » voulait dire « pas une symétrie axiale ». Ces tirages
 *     (un tiers des symétries axiales, 11 % de la carte) sont plus durs, ils
 *     sont marqués contenu.difficulte = 'axe_oblique' (FORMATS §0.8,
 *     ECHELONS_DIFFICULTE).
 *   - Carte « Image d'un motif par translation » (image_numero_saisie)
 *     RECADRÉE sur la question 11 : un VRAI pavage sans trou (4 × 3 à 6 × 4
 *     pavés jointifs, 12 à 24 motifs, un même triangle rectangle dans chaque
 *     pavé, jamais plus haut que large), numéros MÉLANGÉS ; « On considère la
 *     translation qui transforme le motif i en le motif j. Quel est le numéro de
 *     l'image du motif k ? » ; l'image existe toujours ; k n'est ni i ni j, la
 *     réponse n'est pas i ; le sens varie (huit directions). Mode auto : le
 *     raccourci « k + (j − i) » (juste sans regarder la figure si les numéros
 *     suivaient les rangées) est écarté par construction, il ne tombe jamais
 *     juste (0 sur 10 000 ; sans cette garde, avec les numéros mélangés, il
 *     tombait juste pour 3,5 % des triplets possibles). Avant : vecteur en
 *     coordonnées, « translatés », quatre ou cinq triangles épars appelés
 *     « pavage », motif 1 en bas à gauche de tous les autres dans 100 % des
 *     tirages. Hexagones du modèle officiel : À ARBITRER (les pavés sont des
 *     rectangles de 3 × 2 ou 2 × 3 carreaux).
 *   - Carte « Vecteur d'un motif à son image » RECADRÉE et RENOMMÉE « Compter
 *     les carreaux d'une translation » (carreaux_texte_trou_saisie, id de carte
 *     « carreaux ») : même pavage (quadrillage visible, motif i en bleu, motif j
 *     en orange), une paire de motifs quelconque, donc le sens varie ; « Cette
 *     translation fait glisser le motif 7 de {{9}} carreaux vers la droite et
 *     de {{4}} carreaux vers le bas. » (la phrase de 187, adaptée : il n'y a pas
 *     de flèche dans un pavage, et « faire glisser » prend son complément) ;
 *     mots de direction FIXÉS par le tirage, seuls les nombres sont des trous.
 *     Une fois sur quatre, une seule direction (paire sur une même rangée ou
 *     une même colonne) et la phrase ne nomme qu'elle. Les pavés font 2 ou 3
 *     carreaux de côté : un déplacement vaut au moins 2 carreaux, « carreaux »
 *     est toujours au pluriel, l'accord ne trahit jamais un « 1 » (même choix
 *     que 187). Parenthèse « (Écris chaque nombre sans espace.) » retirée.
 *     Avant : sept réponses possibles en tout, coordonnées de vecteur ; après :
 *     144 déplacements différents.
 *   - Carte « La transformation d'une frise » (frise_qcm_unique) RECADRÉE :
 *     trois régimes tirés d'abord (translation seule ; miroir alterné, axes
 *     verticaux ; demi-tour alterné), 5 à 7 motifs ; « Voici une frise. Par
 *     quelle transformation passe-t-on du motif 1 au motif 2 ? », une fois sur
 *     quatre « … au motif 3 », toujours une translation (mode auto, À ARBITRER :
 *     le taux). Mesuré : translation servie dans 50 % des tirages, un tiers
 *     (33 à 34 %) des questions « 1 → 2 ». Avant : clé « translation » dans
 *     100 % des tirages et énoncé qui donnait le critère (« glissant », « même
 *     orientation », « même sens »). Motif 1 en bleu, motif demandé en orange.
 *   - Déplacement sacrifié (4 carreaux à droite, 1 vers le haut : l'exemple du
 *     cours p. 3) exclu de toutes les cartes : sauté au tirage de « transfo »,
 *     impossible ailleurs (pavés de 2 ou 3 carreaux de haut, frises
 *     horizontales), vérifié par un throw.
 *   - Distracteurs nommés, contrat exporté (REGLES_DISTRACTEURS_QCM), codes dans
 *     _meta.params.distracteurs. La confusion symétrie axiale / demi-tour,
 *     absente de la liste du paquet, reprend le nom de 1245
 *     (demi_tour_pour_axiale).
 *   - Rappel brouillon : AUCUN (décision du paquet) : tout se lit sur la figure.
 *   - Tout par construction : la transformation est RETROUVÉE sur les sommets
 *     (toutes les correspondances de sommets, second chemin) et doit être
 *     unique ; le déplacement est relu sur les motifs placés ; boucles bornées,
 *     repli déterministe par balayage, throw sinon.
 * Quatre formats, dont deux QCM.
 */

import {
    randInt, randomChoice, shuffle, makeQcm, makeSaisie, makeTexteTrou,
} from '../../../utils';

const ATTENDU_ID = 188;
const opts = (label) => ({ niveau: '4eme', matiere: 'maths', attendu: ATTENDU_ID, label });

const L_TRANSFO = 'Reconnaître la transformation';
const L_IMAGE = 'Image d\'un motif par translation';
const L_CARREAUX = 'Compter les carreaux d\'une translation';
const L_FRISE = 'La transformation d\'une frise';

// ═══════════════════════════════════════════════════════════
// Géométrie des motifs (coordonnées entières de carreaux, y vers le haut)
// ═══════════════════════════════════════════════════════════

const minX = (pts) => Math.min(...pts.map((p) => p[0]));
const maxX = (pts) => Math.max(...pts.map((p) => p[0]));
const minY = (pts) => Math.min(...pts.map((p) => p[1]));
const maxY = (pts) => Math.max(...pts.map((p) => p[1]));

/** Les huit isométries du quadrillage qui fixent l'origine : quarts de tour et retournements. */
const ISOMETRIES = [
    ([x, y]) => [x, y], ([x, y]) => [-y, x], ([x, y]) => [-x, -y], ([x, y]) => [y, -x],
    ([x, y]) => [-x, y], ([x, y]) => [x, -y], ([x, y]) => [y, x], ([x, y]) => [-y, -x],
];
const normaliser = (pts) => {
    const mx = minX(pts); const my = minY(pts);
    return pts.map(([x, y]) => [x - mx, y - my]);
};
/**
 * Triangle rectangle de côtés de l'angle droit a et b (a ≠ b : scalène, donc
 * chiral) dans ses huit positions, coin bas gauche de sa boîte en (0 ; 0).
 */
const positionsTriangle = (a, b) => ISOMETRIES.map((f) => normaliser([[0, 0], [a, 0], [0, b]].map(f)));

const translater = (pts, dx, dy) => pts.map(([x, y]) => [x + dx, y + dy]);
// Axes et centres en coordonnées DOUBLÉES (demi-carreaux) : les images restent sur les nœuds.
const symVerticale = (pts, c2) => pts.map(([x, y]) => [c2 - x, y]);        // axe x = c2 / 2
const symHorizontale = (pts, c2) => pts.map(([x, y]) => [x, c2 - y]);      // axe y = c2 / 2
const symDiagonale = (pts, c) => pts.map(([x, y]) => [y - c, x + c]);      // axe y = x + c
const symAntidiagonale = (pts, c) => pts.map(([x, y]) => [c - y, c - x]);  // axe y = −x + c
const demiTour = (pts, cx2, cy2) => pts.map(([x, y]) => [cx2 - x, cy2 - y]); // centre (cx2 / 2 ; cy2 / 2)

const memesSommets = (P, Q) => P.length === Q.length && P.every((p, i) => p[0] === Q[i][0] && p[1] === Q[i][1]);
const dansGrille = (pts, gx, gy) => pts.every(([x, y]) => x >= 0 && x <= gx && y >= 0 && y <= gy);
/** Boîtes séparées d'au moins un carreau, horizontalement ou verticalement. */
const separes = (A, B) => minX(B) >= maxX(A) + 1 || minX(A) >= maxX(B) + 1
    || minY(B) >= maxY(A) + 1 || minY(A) >= maxY(B) + 1;

// ─── Second chemin : la transformation RETROUVÉE sur les sommets ───

const pgcd = (a, b) => (b === 0 ? Math.abs(a) : pgcd(b, a % b));
const PERMUTATIONS_3 = [[0, 1, 2], [0, 2, 1], [1, 0, 2], [1, 2, 0], [2, 0, 1], [2, 1, 0]];
/** Médiatrice de [PQ] en entiers réduits : a x + b y = c. */
const mediatrice = ([px, py], [qx, qy]) => {
    let a = 2 * (qx - px); let b = 2 * (qy - py); let c = qx * qx + qy * qy - px * px - py * py;
    const g = pgcd(pgcd(a, b), c) || 1;
    a /= g; b /= g; c /= g;
    if (a < 0 || (a === 0 && b < 0)) { a = -a; b = -b; c = -c; }
    return [a, b, c];
};
/**
 * Toutes les transformations (translation, demi-tour, symétrie d'axe
 * quelconque) qui envoient le triangle A sur le triangle B, en essayant toutes
 * les correspondances de sommets. Indépendant de la façon dont B a été
 * construit : c'est la vérification de chaque tirage.
 */
const transformationsPossibles = (A, B) => {
    const types = new Set();
    PERMUTATIONS_3.forEach((perm) => {
        const Q = perm.map((k) => B[k]);
        const d = A.map(([x, y], i) => [Q[i][0] - x, Q[i][1] - y]);
        if (d.every(([dx, dy]) => dx === d[0][0] && dy === d[0][1]) && (d[0][0] !== 0 || d[0][1] !== 0)) types.add('translation');
        const s = A.map(([x, y], i) => [Q[i][0] + x, Q[i][1] + y]);
        if (s.every(([sx, sy]) => sx === s[0][0] && sy === s[0][1])) types.add('centrale');
        const mobiles = A.map((P, i) => [P, Q[i]]).filter(([P, R]) => P[0] !== R[0] || P[1] !== R[1]);
        if (!mobiles.length) return;
        const lignes = mobiles.map(([P, R]) => mediatrice(P, R).join(','));
        if (lignes.some((l) => l !== lignes[0])) return;
        const [a, b, c] = lignes[0].split(',').map(Number);
        const fixesSurAxe = A.every((P, i) => (P[0] !== Q[i][0] || P[1] !== Q[i][1]) || a * P[0] + b * P[1] === c);
        if (fixesSurAxe) types.add('axiale');
    });
    return types;
};

/** Le déplacement sacrifié du cours (p. 3) : 4 carreaux à droite, 1 vers le haut. */
const estSacrifie = (dx, dy) => dx === 4 && dy === 1;

// ═══════════════════════════════════════════════════════════
// Figures (dessinées ici ; couleurs du parc)
// ═══════════════════════════════════════════════════════════

const BLEU = '#1E3A8A';
const ORANGE = '#b45309';
const GRIS = '#64748b';
const TRAIT_GRILLE = '#e2e8f0';
const TRAIT_PAVE = '#94a3b8';
const PAD = 12;
const TAILLE_NUMERO = 13;

const arr1 = (v) => Math.round(v * 10) / 10;

/** Centre du cercle inscrit : toujours à l'intérieur du triangle, loin des trois côtés. */
const centreInscrit = ([A, B, C]) => {
    const d = (P, Q) => Math.hypot(P[0] - Q[0], P[1] - Q[1]);
    const a = d(B, C); const b = d(A, C); const c = d(A, B);
    const p = a + b + c;
    return [(a * A[0] + b * B[0] + c * C[0]) / p, (a * A[1] + b * B[1] + c * C[1]) / p];
};

/**
 * Figure : quadrillage de gx × gy carreaux (s pixels par carreau), pavés
 * (rectangles d'un pavage), motifs numérotés. Rien hors du viewBox : la marge
 * PAD couvre l'épaisseur des traits ; les numéros sont dans les triangles.
 * Pas de dominant-baseline (retiré par le nettoyage du SVG dans l'app) : le
 * numéro est centré par un décalage vertical.
 */
const svgFigure = ({ gx, gy, s, quadrillage = true, paves = [], motifs = [] }) => {
    const W = 2 * PAD + gx * s; const H = 2 * PAD + gy * s;
    const px = (x) => arr1(PAD + x * s);
    const py = (y) => arr1(PAD + (gy - y) * s);
    const out = [
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" width="${W}" height="${H}" font-family="system-ui, sans-serif">`,
        `<rect x="0" y="0" width="${W}" height="${H}" fill="white"/>`,
    ];
    if (quadrillage) {
        for (let x = 0; x <= gx; x++) out.push(`<line x1="${px(x)}" y1="${py(gy)}" x2="${px(x)}" y2="${py(0)}" stroke="${TRAIT_GRILLE}" stroke-width="1"/>`);
        for (let y = 0; y <= gy; y++) out.push(`<line x1="${px(0)}" y1="${py(y)}" x2="${px(gx)}" y2="${py(y)}" stroke="${TRAIT_GRILLE}" stroke-width="1"/>`);
    }
    paves.forEach((p) => {
        out.push(`<rect class="pave" x="${px(p.x)}" y="${py(p.y + p.h)}" width="${p.w * s}" height="${p.h * s}" fill="none" stroke="${TRAIT_PAVE}" stroke-width="1.5"/>`);
    });
    motifs.forEach((m) => {
        const pts = m.pts.map(([x, y]) => `${px(x)},${py(y)}`).join(' ');
        out.push(`<polygon class="motif" points="${pts}" fill="${m.couleur}" fill-opacity="0.14" stroke="${m.couleur}" stroke-width="2" stroke-linejoin="round"/>`);
        const [cx, cy] = centreInscrit(m.pts);
        out.push(`<text class="num" x="${px(cx)}" y="${arr1(py(cy) + 0.36 * TAILLE_NUMERO)}" text-anchor="middle" font-size="${TAILLE_NUMERO}" font-weight="700" fill="${m.couleur}">${m.numero}</text>`);
    });
    out.push('</svg>');
    return out.join('');
};

/** Élément d'énoncé : data-URL en imageUrl (jamais imageData), alt sans la réponse. */
const imageEl = (svg, alt, maxWidth = 'medium') => ({
    version: 1,
    elements: [{ type: 'image', config: { imageUrl: `data:image/svg+xml,${encodeURIComponent(svg)}`, maxWidth, alt } }],
});

// ═══════════════════════════════════════════════════════════
// Les trois transformations (choix des deux QCM, libellés de 1245)
// ═══════════════════════════════════════════════════════════

const TYPES = ['translation', 'axiale', 'centrale'];
const NOMS = {
    translation: 'Une translation.',
    axiale: 'Une symétrie axiale.',
    centrale: 'Un demi-tour (symétrie centrale).',
};
/** Code de l'erreur que matérialise chaque choix faux, selon la bonne transformation. */
const CODES = {
    translation: { axiale: 'glissement_pour_miroir', centrale: 'demi_tour_pour_translation' },
    axiale: { translation: 'glissement_pour_miroir', centrale: 'demi_tour_pour_axiale' },
    centrale: { translation: 'demi_tour_pour_translation', axiale: 'demi_tour_pour_axiale' },
};
const qcmTransformations = (bonne, texte, options) => {
    const autres = TYPES.filter((t) => t !== bonne);
    const payload = makeQcm(TYPES.map((t) => NOMS[t]), NOMS[bonne], texte, options);
    return { payload, distracteurs: autres.map((t) => CODES[bonne][t]) };
};

// ═══════════════════════════════════════════════════════════
// Carte 1 : Reconnaître la transformation (QCM)
// ═══════════════════════════════════════════════════════════

const GX_T = 15;
const GY_T = 10;
const S_T = 26;
const COTES_T = [[3, 2], [4, 2], [4, 3]];
// Position relative du motif 2 (coin bas gauche de sa boîte comparé à celui du
// motif 1) : E, W, N, S = même rangée ou même colonne ; NE, NW, SE, SW = en biais.
const CLASSES_DROITES = ['E', 'W', 'N', 'S'];
const CLASSES_BIAIS = ['NE', 'NW', 'SE', 'SW'];
// Même loi pour les trois types : la position ne renseigne pas sur la réponse.
const P_BIAIS = 1 / 3;
const DIFFICULTE_OBLIQUE = 'axe_oblique';

/**
 * Les échelons de la carte « Reconnaître la transformation », du plus simple
 * au plus coûteux. Donnée pure, jamais lue à l'exécution (FORMATS §0.8).
 */
export const ECHELONS_DIFFICULTE = [
    {
        code: 'axe_ou_centre_droit',
        pose: false,
        geste: 'translation, demi-tour, ou symétrie d\'axe vertical ou horizontal : le motif garde ses côtés horizontaux et verticaux, il suffit de voir s\'il a glissé, s\'il est à l\'envers ou retourné comme dans un miroir',
    },
    {
        code: DIFFICULTE_OBLIQUE,
        pose: true,
        geste: 'symétrie d\'axe oblique (à 45°, non tracé) qui met le motif 2 en biais : ses côtés ont pivoté, il faut voir un retournement là où l\'œil voit d\'abord un quart de tour',
    },
];

const classeDe = (A, B) => {
    const dx = Math.sign(minX(B) - minX(A)); const dy = Math.sign(minY(B) - minY(A));
    return `${dy > 0 ? 'N' : (dy < 0 ? 'S' : '')}${dx > 0 ? 'E' : (dx < 0 ? 'W' : '')}`;
};

/** Toutes les images de m1 par une transformation du type donné (paramètres entiers ou demi-entiers). */
const imagesCandidates = (type, m1) => {
    const out = [];
    if (type === 'translation') {
        for (let dx = -GX_T; dx <= GX_T; dx++) {
            for (let dy = -GY_T; dy <= GY_T; dy++) {
                if ((dx !== 0 || dy !== 0) && !estSacrifie(dx, dy)) out.push({ m2: translater(m1, dx, dy), param: { deplacement: [dx, dy] } });
            }
        }
    } else if (type === 'axiale') {
        for (let c2 = 0; c2 <= 2 * GX_T; c2++) out.push({ m2: symVerticale(m1, c2), param: { axe: `x = ${c2 / 2}` } });
        for (let c2 = 0; c2 <= 2 * GY_T; c2++) out.push({ m2: symHorizontale(m1, c2), param: { axe: `y = ${c2 / 2}` } });
        for (let c = -GX_T; c <= GY_T; c++) out.push({ m2: symDiagonale(m1, c), param: { axe: `y = x + ${c}`, oblique: true } });
        for (let c = 0; c <= GX_T + GY_T; c++) out.push({ m2: symAntidiagonale(m1, c), param: { axe: `y = -x + ${c}`, oblique: true } });
    } else {
        for (let cx2 = 0; cx2 <= 2 * GX_T; cx2++) {
            for (let cy2 = 0; cy2 <= 2 * GY_T; cy2++) out.push({ m2: demiTour(m1, cx2, cy2), param: { centre: [cx2 / 2, cy2 / 2] } });
        }
    }
    return out;
};

const valides = (type, classe, m1) => imagesCandidates(type, m1)
    .filter(({ m2 }) => dansGrille(m2, GX_T, GY_T) && separes(m1, m2) && classeDe(m1, m2) === classe);

const genTransfo = () => {
    const type = randomChoice(TYPES);
    const classe = randomChoice(Math.random() < P_BIAIS ? CLASSES_BIAIS : CLASSES_DROITES);
    const [a, b] = randomChoice(COTES_T);
    const forme = randomChoice(positionsTriangle(a, b));
    const w = maxX(forme); const h = maxY(forme);
    let m1 = null; let choix = null;
    for (let essai = 0; essai < 60 && !choix; essai++) {
        const essaiM1 = translater(forme, randInt(0, GX_T - w), randInt(0, GY_T - h));
        const c = valides(type, classe, essaiM1);
        if (c.length) { m1 = essaiM1; choix = randomChoice(c); }
    }
    // Repli déterministe : balayage de toutes les positions du motif 1.
    for (let x0 = 0; x0 <= GX_T - w && !choix; x0++) {
        for (let y0 = 0; y0 <= GY_T - h && !choix; y0++) {
            const essaiM1 = translater(forme, x0, y0);
            const c = valides(type, classe, essaiM1);
            if (c.length) { m1 = essaiM1; [choix] = c; }
        }
    }
    if (!choix) throw new Error(`gen_188 transfo : aucune position (${type}, ${classe}, ${a}×${b})`);
    const { m2, param } = choix;
    // Second chemin : la transformation retrouvée sur les sommets est unique et c'est la bonne.
    const trouvees = transformationsPossibles(m1, m2);
    if (trouvees.size !== 1 || !trouvees.has(type)) throw new Error(`gen_188 transfo : ${type} retrouvée comme ${[...trouvees].join('+')}`);
    if (type === 'translation' && estSacrifie(m2[0][0] - m1[0][0], m2[0][1] - m1[0][1])) throw new Error('gen_188 transfo : déplacement sacrifié');

    const svg = svgFigure({
        gx: GX_T, gy: GY_T, s: S_T,
        motifs: [{ pts: m1, couleur: BLEU, numero: 1 }, { pts: m2, couleur: ORANGE, numero: 2 }],
    });
    const alt = 'Sur un quadrillage, deux triangles rectangles de même forme et de même taille, numérotés : le motif 1 en bleu, le motif 2 en orange.';
    const { payload, distracteurs } = qcmTransformations(type,
        '<p>Sur le quadrillage, le motif 2 est l\'image du motif 1.</p>'
        + '<p><b>Quelle transformation permet de passer du motif 1 au motif 2 ?</b></p>',
        { ...opts(L_TRANSFO), elements_additionnels: imageEl(svg, alt) });
    if (param.oblique) payload.contenu = { ...payload.contenu, difficulte: DIFFICULTE_OBLIQUE };
    payload._meta.params = {
        type, position: classe, cotes: [a, b], m1, m2, ...param,
        ...(param.oblique ? { difficulte: DIFFICULTE_OBLIQUE } : {}),
        distracteurs,
    };
    return payload;
};

// ═══════════════════════════════════════════════════════════
// Pavage (cartes 2 et 3) : pavés rectangulaires jointifs, sans trou
// ═══════════════════════════════════════════════════════════

// Colonnes × rangées : 12 à 24 pavés (plages du cadrage).
const PAVAGES = [[4, 3], [5, 3], [4, 4], [6, 3], [5, 4], [6, 4]];
// Un pavé fait 3 × 2 ou 2 × 3 carreaux : tout déplacement d'un pavé à un autre
// vaut 0 ou AU MOINS 2 carreaux dans chaque direction (jamais « 1 carreau »,
// jamais le déplacement sacrifié 4 à droite, 1 vers le haut).
const PAVES = [[3, 2], [2, 3]];

/**
 * Un pavage : C × R pavés de W × H carreaux, dans chacun le même triangle
 * rectangle (la moitié du pavé coupé par une diagonale, angle droit dans l'un
 * des quatre coins), numéros de 1 à C × R MÉLANGÉS.
 */
const construirePavage = (decalage = 0) => {
    const [W, H] = randomChoice(PAVES);
    // Jamais plus haut que large : l'app étire la figure à la largeur de son
    // cadre, un pavage de 8 × 12 carreaux y prendrait plus de 700 pixels de haut.
    const [C, R] = randomChoice(PAVAGES.filter(([c, r]) => r * H <= c * W));
    const forme = randomChoice(positionsTriangle(W, H).filter((p) => maxX(p) === W && maxY(p) === H));
    const numeros = shuffle(Array.from({ length: C * R }, (_, k) => k + 1));
    const paves = [];
    for (let r = 0; r < R; r++) {
        for (let c = 0; c < C; c++) {
            const x = decalage + c * W; const y = decalage + r * H;
            paves.push({ c, r, x, y, w: W, h: H, numero: numeros[r * C + c], pts: translater(forme, x, y) });
        }
    }
    const pave = (c, r) => paves.find((q) => q.c === c && q.r === r) || null;
    return { C, R, W, H, paves, pave };
};

/** Second chemin : le motif placé au bout du déplacement A → B à partir de K, relu sur les sommets. */
const imageRelue = (paves, A, B, K) => {
    const dx = B.pts[0][0] - A.pts[0][0]; const dy = B.pts[0][1] - A.pts[0][1];
    if (!memesSommets(translater(A.pts, dx, dy), B.pts) || !transformationsPossibles(A.pts, B.pts).has('translation')) {
        throw new Error('gen_188 pavage : B n\'est pas l\'image de A par une translation');
    }
    const cible = translater(K.pts, dx, dy);
    const trouves = paves.filter((q) => memesSommets(q.pts, cible));
    return trouves.length === 1 ? trouves[0] : null;
};

// ═══════════════════════════════════════════════════════════
// Carte 2 : Image d'un motif par translation (saisie du numéro)
// ═══════════════════════════════════════════════════════════

/** (A, B, K) acceptable : l'image de K existe, K n'est ni A ni B, la réponse n'est pas A, et k + (j − i) est faux. */
const tripletValide = (P, A, B, K) => {
    if (A === B || K === A || K === B) return null;
    const I = P.pave(K.c + (B.c - A.c), K.r + (B.r - A.r));
    if (!I || I === A) return null;
    if (I.numero === K.numero + B.numero - A.numero) return null;
    return I;
};

const genImageNumero = () => {
    const P = construirePavage();
    let A = null; let B = null; let K = null; let I = null;
    for (let essai = 0; essai < 200 && !I; essai++) {
        const a = randomChoice(P.paves); const b = randomChoice(P.paves);
        if (a === b) continue;
        const ks = P.paves.filter((k) => tripletValide(P, a, b, k));
        if (!ks.length) continue;
        A = a; B = b; K = randomChoice(ks); I = tripletValide(P, A, B, K);
    }
    // Repli déterministe : premier triplet valide dans l'ordre des pavés.
    for (let x = 0; x < P.paves.length && !I; x++) {
        for (let y = 0; y < P.paves.length && !I; y++) {
            for (let z = 0; z < P.paves.length && !I; z++) {
                const i = tripletValide(P, P.paves[x], P.paves[y], P.paves[z]);
                if (i) { A = P.paves[x]; B = P.paves[y]; K = P.paves[z]; I = i; }
            }
        }
    }
    if (!I) throw new Error('gen_188 image : aucun triplet');
    // Second chemin : l'image relue sur les sommets est bien le pavé I.
    if (imageRelue(P.paves, A, B, K) !== I) throw new Error('gen_188 image : image relue différente');

    const N = P.C * P.R;
    const svg = svgFigure({
        gx: P.C * P.W, gy: P.R * P.H, s: Math.min(30, Math.floor(420 / (P.C * P.W))), quadrillage: false,
        paves: P.paves, motifs: P.paves.map((q) => ({ pts: q.pts, couleur: BLEU, numero: q.numero })),
    });
    const alt = `Un pavage de ${N} rectangles identiques, en ${P.R} rangées de ${P.C} ; dans chaque rectangle, un triangle rectangle colorié qui porte un numéro de 1 à ${N}.`;
    const payload = makeSaisie(String(I.numero),
        '<p>Voici un pavage : chaque motif porte un numéro.</p>'
        + `<p>On considère la translation qui transforme le motif ${A.numero} en le motif ${B.numero}. `
        + `<b>Quel est le numéro de l'image du motif ${K.numero} ?</b></p>`,
        { ...opts(L_IMAGE), suffixe: '', elements_additionnels: imageEl(svg, alt) });
    const dc = B.c - A.c; const dr = B.r - A.r;
    const inverse = P.pave(K.c - dc, K.r - dr);
    payload._meta.params = {
        pavage: `${P.C}×${P.R}`, pave: `${P.W}×${P.H}`, i: A.numero, j: B.numero, k: K.numero,
        deplacement_paves: [dc, dr], reponse: I.numero,
        erreurs: { sens_inverse: inverse ? inverse.numero : null },
    };
    return payload;
};

// ═══════════════════════════════════════════════════════════
// Carte 3 : Compter les carreaux d'une translation (texte à trous, saisie)
// ═══════════════════════════════════════════════════════════

// Trois fois sur quatre, la paire est en biais et la phrase nomme les deux
// directions ; sinon même rangée ou même colonne, la phrase n'en nomme qu'une.
const P_DEUX_DIRECTIONS = 3 / 4;

const genCarreaux = () => {
    const P = construirePavage(1);
    const deux = Math.random() < P_DEUX_DIRECTIONS;
    const horizontal = randomChoice([true, false]);
    const paires = [];
    P.paves.forEach((A) => P.paves.forEach((B) => {
        const dc = B.c - A.c; const dr = B.r - A.r;
        const ok = deux ? (dc !== 0 && dr !== 0) : (horizontal ? (dc !== 0 && dr === 0) : (dc === 0 && dr !== 0));
        if (ok) paires.push([A, B]);
    }));
    if (!paires.length) throw new Error('gen_188 carreaux : aucune paire');
    const [A, B] = randomChoice(paires);
    // Second chemin : le déplacement relu sur les sommets des deux motifs placés.
    const DX = B.pts[0][0] - A.pts[0][0]; const DY = B.pts[0][1] - A.pts[0][1];
    if (!memesSommets(translater(A.pts, DX, DY), B.pts) || !transformationsPossibles(A.pts, B.pts).has('translation')) {
        throw new Error('gen_188 carreaux : B n\'est pas l\'image de A par une translation');
    }
    if (DX !== (B.c - A.c) * P.W || DY !== (B.r - A.r) * P.H) throw new Error('gen_188 carreaux : déplacement incohérent');
    // « carreaux » reste au pluriel : un « 1 carreau » donnerait la réponse par l'accord.
    if ((DX !== 0 && Math.abs(DX) < 2) || (DY !== 0 && Math.abs(DY) < 2)) throw new Error('gen_188 carreaux : un seul carreau');
    if (estSacrifie(DX, DY)) throw new Error('gen_188 carreaux : déplacement sacrifié');

    const morceaux = [];
    if (DX !== 0) morceaux.push(`de {{${Math.abs(DX)}}} carreaux vers la ${DX > 0 ? 'droite' : 'gauche'}`);
    if (DY !== 0) morceaux.push(`de {{${Math.abs(DY)}}} carreaux vers le ${DY > 0 ? 'haut' : 'bas'}`);
    // « faire glisser » veut un complément : le motif de départ, nommé par l'énoncé.
    const phrase = `Cette translation fait glisser le motif ${A.numero} ${morceaux.join(' et ')}.`;

    const N = P.C * P.R;
    const gx = P.C * P.W + 2; const gy = P.R * P.H + 2;
    const couleur = (q) => (q === A ? BLEU : (q === B ? ORANGE : GRIS));
    const svg = svgFigure({
        gx, gy, s: Math.min(26, Math.floor(420 / gx)),
        paves: P.paves, motifs: P.paves.map((q) => ({ pts: q.pts, couleur: couleur(q), numero: q.numero })),
    });
    const alt = `Sur un quadrillage, un pavage de ${N} rectangles identiques ; dans chacun, un triangle rectangle numéroté ; le motif ${A.numero} est en bleu, le motif ${B.numero} en orange.`;
    const payload = makeTexteTrou(phrase,
        '<p>Voici un pavage sur un quadrillage.</p>'
        + `<p>On considère la translation qui transforme le motif ${A.numero} en le motif ${B.numero}. <b>Complète la phrase.</b></p>`,
        { ...opts(L_CARREAUX), mode: 'saisie', elements_additionnels: imageEl(svg, alt) });
    payload._meta.params = {
        pavage: `${P.C}×${P.R}`, pave: `${P.W}×${P.H}`, i: A.numero, j: B.numero, deplacement: [DX, DY],
    };
    return payload;
};

// ═══════════════════════════════════════════════════════════
// Carte 4 : La transformation d'une frise (QCM)
// ═══════════════════════════════════════════════════════════

// Une question sur quatre porte sur « du motif 1 au motif 3 » (toujours une translation).
const P_MOTIF_3 = 1 / 4;
const GX_FRISE_MAX = 29;

const genFrise = () => {
    const regime = randomChoice(TYPES);
    const cible = Math.random() < P_MOTIF_3 ? 3 : 2;
    const n = randInt(5, 7);
    const forme = randomChoice(positionsTriangle(3, 2));
    const w = maxX(forme); const h = maxY(forme);
    let ecart = randInt(1, 2);
    if (2 + n * w + (n - 1) * ecart > GX_FRISE_MAX) ecart = 1;
    const gx = 2 + n * w + (n - 1) * ecart; const gy = h + 2;
    // Chaque motif est l'image du précédent par la transformation du régime ;
    // l'axe ou le centre est au milieu de l'écart, le centre à mi-hauteur de la bande.
    const motifs = [translater(forme, 1, 1)];
    for (let k = 1; k < n; k++) {
        const prec = motifs[k - 1];
        const c2 = 2 * maxX(prec) + ecart;
        if (regime === 'translation') motifs.push(translater(prec, w + ecart, 0));
        else if (regime === 'axiale') motifs.push(symVerticale(prec, c2));
        else motifs.push(demiTour(prec, c2, 2 + h));
    }
    // Second chemin : chaque passage d'un motif au suivant est retrouvé sur les sommets.
    motifs.forEach((m, k) => {
        if (!dansGrille(m, gx, gy)) throw new Error('gen_188 frise : motif hors du quadrillage');
        if (k === 0) return;
        if (!separes(motifs[k - 1], m)) throw new Error('gen_188 frise : motifs qui se touchent');
        const t = transformationsPossibles(motifs[k - 1], m);
        if (t.size !== 1 || !t.has(regime)) throw new Error(`gen_188 frise : ${regime} retrouvé comme ${[...t].join('+')}`);
    });
    const attendue = cible === 3 ? 'translation' : regime;
    const trouvees = transformationsPossibles(motifs[0], motifs[cible - 1]);
    if (trouvees.size !== 1 || !trouvees.has(attendue)) throw new Error(`gen_188 frise : 1 → ${cible} retrouvé comme ${[...trouvees].join('+')}`);

    const couleur = (k) => (k === 0 ? BLEU : (k === cible - 1 ? ORANGE : GRIS));
    const svg = svgFigure({
        gx, gy, s: Math.min(24, Math.floor(440 / gx)),
        motifs: motifs.map((m, k) => ({ pts: m, couleur: couleur(k), numero: k + 1 })),
    });
    const alt = `Sur un quadrillage, une frise de ${n} triangles rectangles numérotés de 1 à ${n} de gauche à droite ; le motif 1 est en bleu, le motif ${cible} en orange.`;
    const { payload, distracteurs } = qcmTransformations(attendue,
        '<p>Voici une frise.</p>'
        + `<p><b>Par quelle transformation passe-t-on du motif 1 au motif ${cible} ?</b></p>`,
        { ...opts(L_FRISE), elements_additionnels: imageEl(svg, alt, 'large') });
    payload._meta.params = { regime, question: `1 → ${cible}`, motifs: n, pas: w + ecart, distracteurs };
    return payload;
};

// ═══════════════════════════════════════════════════════════
// Contrat des distracteurs (données pures, jamais lues à l'exécution)
// ═══════════════════════════════════════════════════════════

export const REGLES_DISTRACTEURS_QCM = {
    invariants_communs: [
        'trois choix, toujours les mêmes, libellés de 1245 : « Une translation. », « Une symétrie axiale. », « Un demi-tour (symétrie centrale). » ; rotation, homothétie et agrandissement jamais servis, même en distracteur',
        'les deux choix faux sont les deux autres transformations, chacun nommé par la confusion qu\'il matérialise (codes dans _meta.params.distracteurs) ; aucune option inventée',
        'motif chiral (triangle rectangle scalène) : la transformation qui envoie un motif sur l\'autre est RETROUVÉE sur les sommets, toutes correspondances essayées, et doit être unique (throw sinon)',
    ],
    familles: {
        glissement_pour_miroir: 'confondre la translation et la symétrie axiale, dans un sens ou dans l\'autre : la figure retournée comme dans un miroir prise pour une figure qui a glissé (erreur PRINCIPALE du cadrage pour 188)',
        demi_tour_pour_translation: 'confondre le demi-tour et la translation : une figure mise à l\'envers prise pour une figure qui a seulement glissé, ou l\'inverse',
        demi_tour_pour_axiale: 'confondre le demi-tour et la symétrie axiale (nom repris de 1245) : une figure à l\'envers prise pour une figure retournée comme dans un miroir, ou l\'inverse',
    },
    transfo_qcm_unique: 'type tiré d\'abord, un tiers chacun ; position relative du motif 2 tirée ensuite avec la même loi pour les trois types (même rangée ou même colonne deux fois sur trois, en biais une fois sur trois) ; les deux autres transformations en distracteurs',
    frise_qcm_unique: 'régime tiré d\'abord, un tiers chacun (translation seule, miroir alterné d\'axes verticaux, demi-tour alterné) ; question « du motif 1 au motif 2 » (réponse : le régime) trois fois sur quatre, « du motif 1 au motif 3 » (réponse : translation, dans les trois régimes) une fois sur quatre ; les deux autres transformations en distracteurs',
};

// ═══════════════════════════════════════════════════════════
// REGISTRY & EXPORTS
// ═══════════════════════════════════════════════════════════

const GENERATORS = {
    transfo_qcm_unique: genTransfo,
    image_numero_saisie: genImageNumero,
    carreaux_texte_trou_saisie: genCarreaux,
    frise_qcm_unique: genFrise,
};

const CAT = [
    { id: 'transfo', label: L_TRANSFO, key: 'transfo_qcm_unique', fmt: 'QCM' },
    { id: 'image', label: L_IMAGE, key: 'image_numero_saisie', fmt: 'Saisie' },
    { id: 'carreaux', label: L_CARREAUX, key: 'carreaux_texte_trou_saisie', fmt: 'Saisie' },
    { id: 'frise', label: L_FRISE, key: 'frise_qcm_unique', fmt: 'QCM' },
];

export const CATEGORIES = CAT.map((c) => ({
    id: c.id, label: c.label, formatsList: [{ key: c.key, label: c.fmt }],
}));

export const generate = (typeExercice) => {
    let key;
    if (typeExercice && GENERATORS[typeExercice]) key = typeExercice;
    else if (typeExercice) {
        const matching = Object.keys(GENERATORS).filter((k) => k.startsWith(typeExercice) || k.includes(typeExercice));
        key = matching.length ? randomChoice(matching) : randomChoice(Object.keys(GENERATORS));
    } else key = randomChoice(Object.keys(GENERATORS));
    const payload = GENERATORS[key]();
    payload._meta.generatorKey = key;
    return payload;
};

export const _internals = { GENERATORS };
